import React from "react"

export function useAbortController(): {
    getSignal: () => AbortSignal
} {
    const abortControllerRef = React.useRef<AbortController>()

    const getAbortController = React.useCallback(() => {
        if (!abortControllerRef.current) {
            abortControllerRef.current = new AbortController()
        }
        return abortControllerRef.current
    }, [])

    React.useEffect(() => {
        return () => getAbortController().abort()
    }, [getAbortController])

    const getSignal = React.useCallback(() => getAbortController().signal, [getAbortController])

    return {
        getSignal,
    }
}